import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theming/Theming';

const ItemWrapper = styled('div')`
  display: flex;
  align-items: center;
  &.selected {
    font-weight: ${theme.weights.bold};
  }
`;

export const ListSortingItem = ({ selected, item, className = '' }) => {
  return (
    <ItemWrapper className={`${className} ${selected ? 'selected' : ''}`}>
      {item.text}
    </ItemWrapper>
  );
};
